import moment from "moment";
import React, { useEffect, useState } from "react";
import Button from "../../../components/Button";
import InputFileGeneric from "../../../components/InputFileGeneric";
import InputTextarea from "../../../components/InputTextarea";
import Modal from "../../../components/Modal";
import { ModalDelete } from "../../../components/ModalDelete";
import Table from "../../../components/Table";
import { convertIntToMoney } from "../../../helpers/conversions";
import { renderError } from "../../../helpers/errors";
import api from "../../../services/api";

const PaymentReceiptsTab = ({order}) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({rows: [], header:[]});
    const [showCreatePaymentReceipt, setShowCreatePaymentReceipt] = useState(false);
    const [description, setDescription] = useState('');
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [paymentReceiptToDelete, setPaymentReceiptToDelete] = useState(null);

    useEffect(() => {
        generateData();
    }, [order]);

    const generateData = () => {
        const header = ['Cadastrado em', 'Nome do arquivo', 'Descrição', 'Documento', ''];
        const rows = [];
        
        if(order && order.payment_receipts) {
            order.payment_receipts.map(paymentReceipt => {
                rows.push({
                    data: [
                        moment(paymentReceipt.created_at).format('DD/MM/YYYY HH:mm'),
                        paymentReceipt.original_filename || '-',
                        paymentReceipt.description || '-',
                        <a target="_blank" href={paymentReceipt.file_url}>Abrir comprovante</a>
                    ],
                    buttons: [
                        <Button type={`delete`} svg={`delete`} action={() => setPaymentReceiptToDelete(paymentReceipt.id)} />
                    ]
                });
            });
        }

        setData({header, rows});
    }

    const handleFileChange = (selectedFile) => {
        setFile(selectedFile);
        setFileName(selectedFile ? selectedFile.name : '');
    }

    const storePaymentReceipt = () => {
        if(!file){
            alert('Você precisa informar um arquivo');
            return;
        }

        let form = new FormData();
        form.append('order_id', order.id);
        form.append('file', file);
        if(description) {
            form.append('description', description);
        }
        
        setLoading(true);
        api.post(`/order/payment-receipt`, form, { 
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(res => {
            setDescription('');
            setFile(null);
            setFileName('');
            setShowCreatePaymentReceipt(false);
            window.location.reload();
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const deletePaymentReceipt = () => {
        setLoading(true);
        api.delete(`/order/payment-receipt/${paymentReceiptToDelete}`)
            .then(res => {
                window.location.reload();
            }).catch(error => {
                renderError(error);
            }).then(() => {
                setLoading(false);
                setPaymentReceiptToDelete(null);
            });
    }

    return (
        <>
            <ModalDelete
                show={paymentReceiptToDelete !== null}
                close={() => setPaymentReceiptToDelete(null)}
                action={deletePaymentReceipt}
                loading={loading}
            />
            <Modal 
                show={showCreatePaymentReceipt}
                close={() => {
                    setShowCreatePaymentReceipt(false);
                    setDescription('');
                    setFile(null);
                    setFileName('');
                }}
                title={`Cadastrar comprovante de pagamento`}
                footer={
                    <>
                        <Button
                            type={`primary`}
                            size={`small`}
                            text={'Cadastrar'}
                            svg={`save-white`}
                            action={storePaymentReceipt}
                            loading={loading} 
                        />
                    </>
                }
            >
                <div className="section">
                    <InputFileGeneric
                        label="Arquivo"
                        accept=".pdf,.jpeg,.jpg,.png,.gif,.webp"
                        onChange={handleFileChange}
                        fileName={fileName}
                        id="file"
                    />
                    <InputTextarea
                        label="Descrição (opcional)"
                        value={description}
                        change={setDescription}
                        placeholder="Digite uma descrição para o comprovante..."
                    />
                </div>
            </Modal>
            <div className="row">
                <div className="col">
                    <Button 
                        type={`secondary`}
                        size={`small`}
                        text={`Cadastrar comprovante de pagamento`}
                        action={() => setShowCreatePaymentReceipt(true)}
                    />
                    <br />
                </div>
            </div>
            <Table rows={data.rows} header={data.header} loading={loading} />
        </>
    );
} 

export default PaymentReceiptsTab;

